@if (item?.hasTranslationKey) {
  <span>{{ item.label | translate:item.labelParams }}</span>
}
@if (item && !item.hasTranslationKey) {
  <span>{{ item.label }}</span>
}
